'use strict';
const angular = require('angular');

/*@ngInject*/
export function shortcodeFilter($sce) {
  return function(input) {
    if (!input)
      return;

    return $sce.trustAsHtml(input.replace(/\[/g,"<").replace(/\]/g,">"));
  };
}


export default angular.module('conduu.shortcode', [])
  .filter('shortcode', shortcodeFilter)
  .name;



// WEBPACK FOOTER //
// ./client/components/shortcode/shortcode.filter.js